﻿function getButton(e) {
    return $(e.target).siblings('[data-trigger-button]');
}

export function setupMostRead() {

    $('#mobile-more-m-r').on('show.bs.collapse', function (e) {
        getButton(e).text('Less most read');
    });
    $('#mobile-more-m-r').on('hide.bs.collapse', function (e) {
        getButton(e).text('More most read');
    });
    $('#more-most-read').on('show.bs.collapse', function (e) {
        getButton(e).text('Less most read');
    });
    $('#more-most-read').on('hide.bs.collapse', function (e) {
        getButton(e).text('More most read');
    });
    $('#mobile-more-m-s').on('show.bs.collapse', function (e) {
        getButton(e).text('Less most shared');
    });
    $('#mobile-more-m-s').on('hide.bs.collapse', function (e) {
        getButton(e).text('More most shared');
    });
    $('#more-most-shared').on('show.bs.collapse', function (e) {
        getButton(e).text('Less most shared');
    });
    $('#more-most-shared').on('hide.bs.collapse', function (e) {
        getButton(e).text('More most shared');
    });
    $('#mobile-more-m-c').on('show.bs.collapse', function (e) {
        getButton(e).text('Less most commented');
    });
    $('#mobile-more-m-c').on('hide.bs.collapse', function (e) {
        getButton(e).text('More most commented');
    });
    $('#more-most-commented').on('show.bs.collapse', function (e) {
        getButton(e).text('Less most commented');
    });
    $('#more-most-commented').on('hide.bs.collapse', function (e) {
        getButton(e).text('More most commented');
    });
}
